import { useTheme } from '@/hooks/useTheme'

interface TwitterEmbedProps {
    tweetId: string
    title?: string
}

export function TwitterEmbed({ tweetId, title }: TwitterEmbedProps) {
    const { theme } = useTheme()

    return (
        <div className="rounded-lg overflow-hidden border border-border-light dark:border-border-dark bg-white dark:bg-black">
            <iframe
                className="w-full"
                height="350"
                src={`https://platform.twitter.com/embed/Tweet.html?id=${tweetId}&theme=${theme}`}
                // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- empty title should fall back to the default label, not render blank
                title={title || 'X post'}
                allowFullScreen
                loading="lazy"
                sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
            />
        </div>
    )
}
